<template>
    <div data-v-6ebeef4c>
        <div data-v-6329d9d2="" data-v-6ebeef4c="" class="el-col el-col-24">
            <div data-v-6329d9d2="" class="C-UserCenterMenu">
                <a href="/usercenter" :style="{color:colors}"><div data-v-6329d9d2="" class="MenuItem" :class="{active:usercenter}">
                    <div data-v-6329d9d2="" class="Icon"><svg data-v-73b7ef61="" data-v-6329d9d2=""
                            aria-hidden="true" class="svg-icon">
                            <use data-v-73b7ef61="" xlink:href="#icon-user"></use>
                        </svg></div>
                    <div data-v-6329d9d2="" class="Title">会员中心</div>
                </div></a>
                <a href="/publish" :style="{color:colors}"><div data-v-6329d9d2="" class="MenuItem" :class="{active:publish}">
                    <div data-v-6329d9d2="" class="Icon"><svg data-v-73b7ef61="" data-v-6329d9d2="" aria-hidden="true"
                            class="svg-icon">
                            <use data-v-73b7ef61="" xlink:href="#icon-publish"></use>
                        </svg></div>
                    <div data-v-6329d9d2="" class="Title">信息发布</div>
                </div></a>
                <a href="/myinfo" :style="{color:colors}"><div data-v-6329d9d2="" class="MenuItem" :class="{active:myinfo}">
                    <div data-v-6329d9d2="" class="Icon"><svg data-v-73b7ef61="" data-v-6329d9d2="" aria-hidden="true"
                            class="svg-icon">
                            <use data-v-73b7ef61="" xlink:href="#icon-info"></use>
                        </svg></div>
                    <div data-v-6329d9d2="" class="Title">我的信息</div>
                </div></a>
                <a href="/myfavorite" :style="{color:colors}"><div data-v-6329d9d2="" class="MenuItem" :class="{active:myfavorite}">
                    <div data-v-6329d9d2="" class="Icon"><svg data-v-73b7ef61="" data-v-6329d9d2="" aria-hidden="true"
                            class="svg-icon">
                            <use data-v-73b7ef61="" xlink:href="#icon-noheart"></use>
                        </svg></div>
                    <div data-v-6329d9d2="" class="Title">我的收藏</div>
                </div></a>
                <a href="/upgrade" :style="{color:colors}"><div data-v-6329d9d2="" class="MenuItem" :class="{active:upgrade}">
                    <div data-v-6329d9d2="" class="Icon"><svg data-v-73b7ef61="" data-v-6329d9d2="" aria-hidden="true"
                            class="svg-icon">
                            <use data-v-73b7ef61="" xlink:href="#icon-vip"></use>
                        </svg></div>
                    <div data-v-6329d9d2="" class="Title">升级vip</div>
                </div></a>
                <a href="/editprofile" :style="{color:colors}"><div data-v-6329d9d2="" class="MenuItem" :class="{active:profile}">
                    <div data-v-6329d9d2="" class="Icon"><svg data-v-73b7ef61="" data-v-6329d9d2=""
                            aria-hidden="true" class="svg-icon">
                            <use data-v-73b7ef61="" xlink:href="#icon-user-management"></use>
                        </svg></div>
                    <div data-v-6329d9d2="" class="Title">修改资料</div>
                </div></a>
                <a href="/logout" :style="{color:colors}"><div data-v-6329d9d2="" class="MenuItem">
                    <div data-v-6329d9d2="" class="Icon"><svg data-v-73b7ef61="" data-v-6329d9d2="" aria-hidden="true"
                            class="svg-icon">
                            <use data-v-73b7ef61="" xlink:href="#icon-exit"></use>
                        </svg></div>
                    <div data-v-6329d9d2="" class="Title">登出</div>
                </div></a>
                <div data-v-6329d9d2="" class="el-dialog__wrapper" style="display: none;">
                    <div role="dialog" aria-modal="true" aria-label="提示" class="el-dialog" style="margin-top: 15vh;">
                        <div class="el-dialog__header"><span class="el-dialog__title">提示</span></div>
                        <div class="el-dialog__footer"><span data-v-6329d9d2="" class="dialog-footer"><button
                                    data-v-6329d9d2="" type="button" class="el-button el-button--default"><span>取
                                        消</span></button> <button data-v-6329d9d2="" type="button"
                                    class="el-button el-button--primary"><span>确 定</span></button></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cookie from 'js-cookie'
export default {
    name: 'usertop',
    data() {
        return {

            usercenter:'',
            publish:'',
            myinfo:'',
            myfavorite:'',
            upgrade:'',
            profile:'',

            colors:'',

        }
    },
    mounted() {

        let rt = this.$route.name
        if(rt==='usercenter'){

            this.usercenter = true

        }else if(rt==='publish'){

            this.publish = true

        }else if(rt==='myinfo'){

            this.myinfo = true

        }else if(rt==='myfavorite'){

            this.myfavorite = true

        }else if(rt==='upgrade'){

            this.upgrade = true

        }else if(rt==='editprofile'){

            this.profile = true

        }

        let userpuid = cookie.get('sessionid')
        if (!userpuid) {

            window.location.href = 'login'

        }


        this.colors = '#666'

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/usertop.vue